import React from 'react';
import { Section } from './Section';
export function BigIdea() {
  return <Section tone="ink" className="py-20 md:py-32" data-id="element-21" data-mp="2p9y8reamf26h">
      <div className="mx-auto flex max-w-[720px] flex-col items-center text-center" data-id="element-22" data-mp="2p8delps7xl95">
        <h2 className="font-serif text-[28px] leading-[1.2] sm:text-[38px]" data-id="element-23" data-mp="2ua2t5fengh1z">
          La diferencia entre la organizadora que cobra 300 dólares y la que
          cobra 3.000 no es talento.
        </h2>

        <p className="mt-8 font-serif text-4xl italic text-gold sm:text-6xl" data-id="element-24" data-mp="21lormpocr2lo">
          Es el sistema.
        </p>

        <div className="rule-gold mt-10" aria-hidden="true" data-id="element-25" data-mp="26jqb3bpox3xo" />

        <p className="measure mt-10 text-[15px] leading-relaxed text-ivory/70 sm:text-base" data-id="element-26" data-mp="2bi9x1c4aafq1">
          El talento te consigue los "qué lindo te quedó". El sistema te
          consigue el negocio. Y hasta hoy nadie te entregó el sistema:
          aprendiste mirando, haciendo y pagando tus propios errores.
        </p>
      </div>
    </Section>;
}